import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { Field, ErrorMessage } from "formik";
import { BsChevronDown } from "react-icons/bs";

const CMSFormSelect = forwardRef((props, ref) => {
  const {
    label,
    name,
    form,
    options,
    selected,
    autoFocus,
    placeholder,
    required,
    className,
    onChange,
    filter,
    ...rest
  } = props;

  const wrapperRef = useRef(null);

  // Expose scrollIntoView & focus to parent
  useImperativeHandle(ref, () => ({
    scrollIntoView: () => {
      wrapperRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    focus: () => {
      wrapperRef.current?.querySelector("select")?.focus();
    },
  }));

  return (
    <div ref={wrapperRef} className="form-group relative w-full">
      {/* Label */}
      {label && (
        <label
          htmlFor={name}
          className={`text-[19px] lg:text-21pt  text-green ${
            required ? "required" : "notRequired"
          } ${form.touched[name] && form.errors[name] ? "isInvalidText" : ""}`}
        >
          {label} {required  && <span className="text-20pt text-orange">*</span>}
        </label>
      )}

      {/* Select wrapper */}
      <div className={className ? `relative ${className}` : "relative 2.5xl:max-w-[354px]"}>
        {/* Custom icon */}
        <BsChevronDown className="absolute right-5 bottom-[20px] text-green pointer-events-none" />

        <Field
          as="select"
          autoFocus={autoFocus}
          id={name}
          name={name}
          value={selected}
          onChange={onChange}
          className={`form-control w-full font-mono  h-[56px] px-4 pr-12 rounded-[15px] border border-green mt-1 text-18pt 
            bg-white appearance-none focus:outline-none focus:ring-2 focus:ring-green focus:ring-opacity-50
            ${className ? className : "2.5xl:max-w-[354px]"} 
            ${filter ? "filterPartial" : "customInput"} 
            ${form.touched[name] && form.errors[name] ? "is-invalid" : ""}`}
          {...rest}
        >
          <option value={placeholder?.value || ""}>{placeholder?.label || "Select"}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Field>
      </div>

      {/* Error Message */}
      {form.touched[name] && form.errors[name] && (
        <span id={`${name}-error`} className="errorMessage text-red-600 text-14pt">
          <ErrorMessage name={name} />
        </span>
      )}
    </div>
  );
});

export default CMSFormSelect;
